(function($){
	
$(document).ready(function(){
	windowResizeMode();
	adminScroll();
	topScroll();
	mobileDetection();
	browserDetect();
    // matchHeight

    // $('#news .item').matchHeight();
    // $('.futura-category .item-list__wrapper .item-wrapper').matchHeight();
    // $('prestige-category .item-wrapper').matchHeight();
    // $('.details__block-item').matchHeight();

    // $('.prestige-category .item-wrapper').matchHeight();
	// $('.prestige-category .details-wrapper').matchHeight();
	$('.close-btn').click(function(){ 
        $('.search-header').removeClass('in');
	});
	$('.m-links a').tooltip();
	// $('.user-menu > div').matchHeight(); 
	$('.disable-click').click(function( event ) {
        return false;
	});	 
	$('#top').click(function(){
		$('html, body').animate({scrollTop:3}, '800');
	});
	// $('.article--paragraph p').not(":first-child").hide()
	$('.page-articles .item--description').readmore({
		speed: 500,
		embedCSS: true,
		collapsedHeight: 315,
		heightMargin: 18,
		moreLink: '<a href="#" style=""></a>',
		lessLink: '<a href="#" style=""></a>',
		
});
	// Validator
	$('.has-validator').validator().on('submit', function (e) {
		if (e.isDefaultPrevented()) {
			// swal({
			//     position: 'center',
			//     type: 'error',
			//     title: 'Please enter a valid email address.',
			//     showConfirmButton: true,
			//     confirmButtonText: "OK",
			//     timer: 8000
			// })
			console.log('Please fill out the fields!');
		}else { 
			console.log('Success!');
		}
	}); 
	// Newsletter
	$('#newsletter').validator().on('submit', function (e) {


		if (e.isDefaultPrevented()) {
			// swal({
			//     position: 'center',
			//     type: 'error',
			//     title: 'Please enter a valid email address.',
			//     showConfirmButton: true,
			//     confirmButtonText: "OK",
			//     timer: 8000
			// })
			// console.log('Please enter a valid email address');
			// const toast = swal.mixin({
			// 	toast: true,
			// 	position: 'top-end',
			// 	showConfirmButton: false,
			// 	timer: 3000
			// });
			  
			// toast({
			// 	type: 'success',
			// 	title: 'Signed in successfully'
			// })

		}else {
	
			$('.form-submit').attr('disabled', true);
			
			var email = $('#email_data').val();

			var source = $('#source_data').val();

			var url_data = $('#url_data').val();

			var csrf_token = $('meta[name="csrf-token"]').attr('content');

			  $.post("/subscription/submit",
			  { email: email, source: source, url_data: url_data, _token: csrf_token },
			  function(data){
				$('#email_data').val('');
				$('.form-submit').attr('disabled', false);
				swal({
					position: 'center',
					type: 'success',
					title: 'Thank you for subscribing!',
					showConfirmButton: true,
					confirmButtonText: "Close",
					timer: 8000
				})
			  });

			e.preventDefault();
			e.stopPropagation();

		}
	});


	$('.main--slick').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		// asNavFor: '.slick--nav',
		nextArrow: $('.slide .right.carousel-control'),
		prevArrow: $('.slide .left.carousel-control'),

});
// $('.nav--slick').slick({
// 		infinite: true,
// 		slidesToShow: 4,
// 		slidesToScroll: 1,
// 		asNavFor: '.main--slick',
// 		focusOnSelect: true,
// 		// centerMode: true,
// 		// arrows: true,
// 		// nextArrow: $('.relative .arrow.right'),
// 		// prevArrow: $('.relative .arrow.left'),
// 		responsive: [{
// 				breakpoint: 767,
// 				settings: {
// 						slidesToShow: 2
// 				}
// 		}]


// });


	$('.popup-ad .cancel-icon').on('click', function() {
		$('.popup-ad').fadeOut(500, 0);
	});

	// var hslider = $('.h-slider .item');
	
	// hslider.each(function(){
  	
 //  		$(this).css('width', (100 / hslider.length) + '%');
	
	// });
	
});

$('a.disabled').on("click", function (e) {
	e.preventDefault();
});

$(".cookies-wrapper .close-cp").click(function(e) {
	e.preventDefault();
	$(".cookies-wrapper").fadeOut(800, 0);
});

// function cookieFooter(){

// 	document_height = $(document).height();

// 	if($(window).scrollTop() + $(window).height() == document_height) {

// 		$('.cookies-wrapper').addClass('append');
   
//     }else{

//    		cookie_height = $('.cookies-wrapper').height();

// 		minus_height = (document_height - cookie_height) - 150;

// 		if ($(window).scrollTop() + $(window).height() < minus_height) {
			
// 			$('.cookies-wrapper').removeClass('append');
			
// 		}
//    }

// }

jQuery(function(){
  jQuery(document).scroll(function () {

    if (jQuery(window).scrollTop() + jQuery(window).height() > jQuery(document).height() -100) {

		$('.cookies-wrapper').addClass('append');

    }else{

    	if (jQuery(document).height() - 500 > jQuery(window).scrollTop() + jQuery(window).height()) {
			$('.cookies-wrapper').removeClass('append');

    	}

    }
  });
});

// cookieFooter();

$(window).scroll(function() {
	
	// cookieFooter();

});

$(window).on("load", function () {  
	// Scroll to top on page refresh
	// $('body').removeClass('processing-page-load'); 
	// Show the main wrapper when the page is fully loaded
	// Remove page loading when the page is fully loaded
	// $('body').removeClass('processing-page-load');
	$('.main-wrapper').fadeTo(2000, 1); 
	
	$('body').removeClass('processing-page-load');
	$('.page-loading').fadeTo( "slow", 0 ).css({ 
		'visibility' :'hidden',
	}).remove();
});   

$(window).on('scroll', function(){  
	adminScroll(); 
	topScroll();
});

function topScroll() {
	var ofs = window.pageYOffset; 
	if(ofs > 300) {
		$('#top').addClass('show');
	}else {
		$('#top').removeClass('show');
	}
}
function adminScroll() {
	var amheight = $('.admin-menu').innerHeight();
	
	var ofs = window.pageYOffset; 

	if(ofs > amheight) {
		$('.admin-menu').addClass('admin-menu-scrolled'); 
	}else {
		$('.admin-menu').removeClass('admin-menu-scrolled');
	}
}

$(window).on('resize', function(){
	// windowResizeMode();
	mobileDetection();
});

function windowResizeMode() {
	
	var width = $(window).width();

	if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) isMobile = true;

	
    if(width < 768) { 
        $('.field-beds').appendTo($(".front .block--search .form-group__wrapper > div, .page-categories .block--search .form-group__wrapper > div"));
        $('.search-action-area').insertAfter($(".block--search #advance-search"));
        $('.front .block--search, .page-categories .block--search').insertAfter('.block--banner');
        // $('.page-search .filter-results').insertAfter(".filter-tabs");
    }else {
		$('.search-action-area').insertAfter($(".front .block--search .form-group__wrapper"));
		$('.front .block--search, .page-categories .block--search').appendTo($(".block--banner"));
		$('.field-beds').insertBefore($(".front .block--search .field-sub-location, .page-categories .block--search .field-sub-location"));
    }
}

function mobileDetection() {
	var isMobile = false; // initiate as false
	if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) isMobile = true;

	if(!isMobile) {
		$('body').addClass('isDesktop').removeClass('isMobile');
		// Dropdown
		$('.navbar .dropdown').mouseover(function(){
			$(this).addClass('open');
		});
				
		$('.navbar .dropdown').mouseout(function(){
			$(this).removeClass('open');
		});

		$('.navbar .dropdown').click(function(){
			el =  $(this);
			window.location.href = el.children('a').attr('href');
		});
	}else {
		$('body').addClass('isMobile').removeClass('isDesktop');
		// $('.navbar .dropdown').click(function(){
		// 	$(this).toggleClass('open');
		// 	console.log('test');
		// });
	}
}
function browserDetect() { 
	if((navigator.userAgent.indexOf("Opera") || navigator.userAgent.indexOf('OPR')) != -1 ) 
   {
	  $('body').addClass('opera-browser');
   }
   else if(navigator.userAgent.indexOf("Chrome") != -1 )
   {
	$('body').addClass('chrome-browser');

   }
   else if(navigator.userAgent.indexOf("Safari") != -1)
   {
	$('body').addClass('safari-browser');

   }
   else if(navigator.userAgent.indexOf("Firefox") != -1 ) 
   {
	$('body').addClass('firefox-browser');

   }
   else if((navigator.userAgent.indexOf("MSIE") != -1 ) || (!!document.documentMode == true )) //IF IE > 10
   {
	$('body').addClass('ie-browser');

   }  
   else 
   {
	$('body').addClass('browser-browser');
	  
   }
   }
})(jQuery);


